<template>
  <div class="container">
    <legend>Настройка расходов</legend>
    <div>
      <expense-type
        :expense-groups="ExpenseGroups"
        :expense-type="ExpenseType"
        @onchange="saveExpenseType"
        @removeExpenseType="removeExpenseType"
        v-for="ExpenseType in ExpenseTypes"></expense-type>

        <form @submit.prevent="addExpenseType" class="row d-flex flex-row mb-2">
          <div class="col col-auto" style="width: 300px">
            <input class="form-control" type="text" v-model="newExp.Name">
          </div>
          <div class="col col-auto" style="width: 300px">
            <v-select
              :options="ExpenseGroups"
              :reduce="item => item.Id"
              :taggable="true"
              label="Name"
              style="min-width: 200px"
              v-model="newExp.ExpenseGroupId"
              :createOption="createGroup"

            >
              <template #search="{attributes, events}">
                <input
                  :required="!newExp.ExpenseGroupId"
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
          <div class="col col-auto">
            <button class="btn btn-outline-success" type="submit">Добавить</button>
          </div>
        </form>
      </div>
    </div>
</template>
<script>
import ExpenseType from '@/admin/modules/ExpenseSettings/_components/ExpenseType.vue';
import { get, post } from '@/admin/services/api/http-utils';

const masterNewExp = {
  Name: '',
  ExpenseGroupId: null,
};
export default {
  components: {
    ExpenseType,
  },
  data() {
    return {
      ExpenseTypes: [],
      ExpenseGroups: [],
      newExp: Object.assign({}, masterNewExp),
    };
  },
  async mounted() {
    await this.fetchExpenseTypes();
    await this.fetchGroups();
  },
  methods: {
    async fetchExpenseTypes() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow/expense-types`);
      this.ExpenseTypes = data;
    },
    async fetchGroups() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow/groups`);
      this.ExpenseGroups = data;
    },
    async saveExpenseType(ExpenseType) {
      await post(`${process.env.VUE_APP_API_HOST}admin/flow/expense-types-save`, ExpenseType);
    },
    async addExpenseType() {
      await post(`${process.env.VUE_APP_API_HOST}admin/flow/expense-types-add`, this.newExp);
      await this.fetchExpenseTypes();
      this.newExp = Object.assign({}, masterNewExp);
    },
    async createGroup(newOption) {
      const { data } = await post(`${process.env.VUE_APP_API_HOST}admin/flow/create-group`, { name: newOption });
      await this.fetchGroups();
      this.form.ExpenseGroupId = data;
    },
    async removeExpenseType(ExpenseType) {
      if (!confirm('Удалить?')) {
        return false;
      }
      await post(`${process.env.VUE_APP_API_HOST}admin/flow/remove`, ExpenseType);
      await this.fetchExpenseTypes();
    },
  },
};
</script>
